import CheckBox from 'devextreme-react/check-box';
import { useContext } from 'react';
import { useAuth } from '../../../../contexts/auth';
import { Card, Field } from '../../../../layouts';
import { CompanyTypes } from '../../../../types/enums';
import { PurchaseOrderContext } from '../context/PurchaseOrderContext';

export default function CFIInformationCard() {

	const { order } = useContext(PurchaseOrderContext);

	const { user } = useAuth();
	const isServiceProvider = user?.companyTypeId === CompanyTypes.SERVICE_PROVIDER;

	return (
		<Card header={order.details.isSampleOrder ? 'Ship To Location' : 'CFI Information'} className="field-label-35">
			{
				isServiceProvider ?
					<>
						<Field label={'CFI Name'} >
							{order.details.cfi.companyName}
						</Field>
						<Field label={'Address'} >
							{order.details.cfi.PA_Address1}
						</Field>
						<Field label={''} visible={!!order.details.cfi.PA_Address2} >
							{order.details.cfi.PA_Address2}
						</Field>
						<Field label={'City'} >
							{order.details.cfi.PA_City + ',' + order.details.cfi.PA_State + ' ' + order.details.cfi.PA_Zip}
						</Field>
						<Field label={'Phone'} >
							{order.details.cfi.phone}
						</Field>
						<Field label={'Email'} >
							<a href={'mailto:' + order.details.cfi.email}>
								{order.details.cfi.email}
							</a>
						</Field>
					</>
					:
					order.details.isSampleOrder && order.details.isDirectShipment ?
						<>
							<Field label={'Customer Name'}>
								{order.details.customerName}
							</Field>
							<Field label={'Phone'}>
								{order.details.customerPhone}
							</Field>
							<Field label={'Email'} visible={!!order.details.customerEmail}>
								<a href={'mailto:' + order.details.retailOrder.customerEmail}>
									{order.details.retailOrder.customerEmail}
								</a>
							</Field>
							<Field label={'Address'} >
								{order.details.customerAddress}
							</Field>
							<Field label={'City'} >
								{order.details.customerCityStateZip}
							</Field>
						</>
						:
						order.details.isSampleOrder && !order.details.isDirectShipment ?
							<>
								<Field label={'Store Name'}>
									{order.details.storeName}
								</Field>
								<Field label={'Phone'}>
									{order.details.storePhone}
								</Field>
								<Field label={'Email'} visible={!!order.details.storeEmail}>
									{order.details.storeEmail}
								</Field>
								<Field label={'Address'} >
									{order.details.storeAddress}
								</Field>
								<Field label={'City'} >
									{order.details.storeCityStateZip}
								</Field>
							</>
							:
							<>
								<Field label={'CFI Name'} >
									{order.details.cfiName}
								</Field>
								<Field label={'CFI Material PO #'}>
									{order.details.comPONumber}
								</Field>
								<Field label={'Contact Name'}>
									{order.details.cfiContactName}
								</Field>
								<Field label={'Address'} >
									{order.details.cfiAddress}
								</Field>
								<Field label={'City'} >
									{order.details.cfiCityStateZip}
								</Field>
								<Field label={'Will Call'}>
									<CheckBox value={order.details.willCall} readOnly={true} />
								</Field>
							</>
			}
		</Card>
	);
}
